import * as React from "react";
import { Step1Page as FormationStep1Page } from "./step_1";
import { CompletedPage as FormationCompletedPage } from "./completed";
import { Step2Page as FormationStep2Page } from "./step_2";
import { Step3Page as FormationStep3Page } from "./step_3";
import { Step4Page as FormationStep4Page } from "./step_4";
import { Step5Page as FormationStep5Page } from "./step_5";
import { Step6Page as FormationStep6Page } from "./step_6";
import { WelcomePage as FormationWelcomePage } from "./welcome";
import { Outlet } from "react-router-dom";
import { Container } from "@/components/core/container";


function FormationLayout(){
    return <Container className="pt-6 pb-12">
        <div>
            <Outlet/>
            </div>
    </Container>
}
// Set the type interface for a Question (string) and possible answers (string[])
export interface Question {
    question: string;
    answers: string[];
    correctAnswer: number;
    explanation: string;
}



export { FormationStep1Page, 
    FormationStep2Page, 
    FormationStep3Page, 
    FormationStep4Page, 
    FormationStep5Page, 
    FormationStep6Page, 
    FormationLayout, 
    FormationWelcomePage,
    FormationCompletedPage
};
export { Exam } from "./exam";
export { Step } from "./step";